var TagCloudDefault = require('../views/tagcloud/tagCloudDefault');
var Ranking = require('../views/viscanvas/ranking');

var VIEWS = {
    VISCANVAS : {
        ranking: Ranking
        // detailedView: DetailedView
    },
    TAGCLOUD : {
        default: TagCloudDefault
    //    ,landscape: LandscapeTagCloud
    }    
};


module.exports = VIEWS;


//////////////////
// WEBPACK FOOTER
// ../src/js/config/views.js
// module id = 47
// module chunks = 0